export default "__VITE_ASSET__Be8Lx5kk__"